var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColorPaletteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 000 20 1.665 1.665 0 001.667-1.667 1.63 1.63 0 00-.428-1.117 1.668 1.668 0 011.25-2.773h1.961A5.558 5.558 0 0022 10.889C22 5.977 17.523 2 12 2zM5.889 12a1.667 1.667 0 110-3.334 1.667 1.667 0 010 3.334zm3.334-4.444a1.667 1.667 0 11-.003-3.334 1.667 1.667 0 01.003 3.334zm5.556 0a1.667 1.667 0 11.002-3.334 1.667 1.667 0 01-.004 3.334h.002zM18.11 12a1.667 1.667 0 110-3.334 1.667 1.667 0 010 3.334z"
  })));
}
export default SvgColorPaletteIcon;